export const UNDO_REDO_TYPE = 'wix-rich-content-undo-redo';
